var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookIcon = function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.665.23v3.675s-2.743-.27-3.43.769c-.375.567-.152 2.229-.185 3.423h3.637c-.307 1.394-.527 2.34-.754 3.548H8.03v11.42H2.99c.002-3.52 0-7.628 0-11.375H.847V8.097h2.12c.109-2.628.15-5.23 1.47-6.557C5.923.05 7.339.23 11.667.23",
    fill: "#1B2132",
    fillRule: "evenodd"
  })));
};
export default SvgFacebookIcon;